import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c4bdc0a0&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bdc0a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4bdc0a0')) {
      api.createRecord('c4bdc0a0', component.options)
    } else {
      api.reload('c4bdc0a0', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=c4bdc0a0&scoped=true", function () {
      api.rerender('c4bdc0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/InputCheckBox/main.vue"
export default component.exports